import styles from "./styles.module.scss";
import DATA from "./DATA";
import React,{ useState } from "react";
import { ChevronDown } from "../Icons";

function MobileInvestigationDetails() {
    const [openIndex, setOpenIndex] = useState(0);

    const handleClick = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className={styles.mobileInvestigationDetails}>
            <h3>調查項目一覽</h3>
            <div>
                {DATA.map((item, index) => (
                    <details 
                        key={index} 
                        className={`${styles.accordionItem} ${openIndex === index ? styles.open : ''}`}
                        open={openIndex === index}
                        onClick={(e) => {
                            e.preventDefault();
                            handleClick(index);
                        }}
                    >
                        <summary>
                            <span>{item.title}</span>
                            <ChevronDown />
                        </summary>
                        <ul>
                            {item.details.map((detail, detailIndex) => (
                                <li key={detailIndex}>
                                    {detail
                                        .split("\n")
                                        .map((line, lineIndex) => (
                                            <React.Fragment key={lineIndex}>
                                                {line}
                                                {lineIndex <
                                                    detail.split("\n").length -
                                                        1 && <br />}
                                            </React.Fragment>
                                        ))}
                                </li>
                            ))}
                        </ul>
                    </details>
                ))}
            </div>
        </div>
    );
}

export default MobileInvestigationDetails;